module.exports = __webpack_public_path__ + "img/logo.54c0b998.png";